import React from "react";
import Brand from "../../layout/WelcomePage/Template/Brand";
import Datetime from "../../layout/DateTime";
import EditAxisPanel from "./EditAxisPanel";
import ChartType from "./ChartType/index";
import BrandsLogicalGroup from "../../layout/WelcomePage/Template/BrandsLogicalGroup";

const ConfigurePanel = ({ setShowChartSettings, firstPage }) => {
  return (
    <div
      className="custom_scroll1 p-2 mr-1"
      style={{
        height: firstPage ? "calc(100vh - 14rem)" : "calc(100vh - 10rem)",
        overflow: "auto",
        paddingRight: "0.5rem",
        scrollbarWidth: "none",
      }}
    >
      <div className="mt-3 floating-label-group header-brands analytics_brand">
        <BrandsLogicalGroup type="widgetMaker" />
        <label
          className="portlet-label floating-label mr-15"
          style={{
            backgroundColor: "#fff",
            top: "-0.8rem",
            fontSize: "1.2rem",
          }}
        >
          Brand
        </label>
      </div>

      <div className="mt-3">
        <Datetime type="widgetMaker" />
      </div>
      <ChartType setShowChartSettings={setShowChartSettings} />
      <div className="mt-3">
        <EditAxisPanel />
      </div>
    </div>
  );
};

export default ConfigurePanel;
